webpackJsonp([114276838955818,60335399758886],{

/***/ 174:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(309);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(174);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: #777;\n  display: inline-block;\n  font-size: ', ';\n  margin: 0 10px;\n  position: relative;\n  text-decoration: none;\n  box-shadow: none;\n  border-bottom: none; \n  \n  &:after {\n    color: #007acc;\n    background: #007acc;\n    content: \'\';\n    display: \'inline-block\';\n    height: 2px;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 100%;\n    transition: 0.25s ease all;\n    width: 0;\n  }\n\n  &:hover {\n    text-decoration: none;\n    color: #007acc;\n    &:after {\n      width: 100%;\n    }\n  }\n'], ['\n  color: #777;\n  display: inline-block;\n  font-size: ', ';\n  margin: 0 10px;\n  position: relative;\n  text-decoration: none;\n  box-shadow: none;\n  border-bottom: none; \n  \n  &:after {\n    color: #007acc;\n    background: #007acc;\n    content: \'\';\n    display: \'inline-block\';\n    height: 2px;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 100%;\n    transition: 0.25s ease all;\n    width: 0;\n  }\n\n  &:hover {\n    text-decoration: none;\n    color: #007acc;\n    &:after {\n      width: 100%;\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GatsbyLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, (0, _typography.rhythm)(0.65));
	
	exports.default = GatsbyLink;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(647);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	    return _react2.default.createElement('img', { src: _logo2.default, alt: 'Logo', style: { width: "50px", margin: "0" } });
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    height: 60px;\n    left: 0px;\n    max-width: 100%;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    z-index: 10;\n'], ['\n    height: 60px;\n    left: 0px;\n    max-width: 100%;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    z-index: 10;\n']);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = Wrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GatsbyLink = __webpack_require__(302);
	
	var _GatsbyLink2 = _interopRequireDefault(_GatsbyLink);
	
	var _Logo = __webpack_require__(303);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Wrapper = __webpack_require__(304);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _reactstrap = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavWrapper = function (_React$Component) {
	  _inherits(NavWrapper, _React$Component);
	
	  function NavWrapper(props) {
	    _classCallCheck(this, NavWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.closeNavbar = _this.closeNavbar.bind(_this);
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  NavWrapper.prototype.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  NavWrapper.prototype.closeNavbar = function closeNavbar() {
	    if (this.state.isOpen == true) {
	      this.toggle();
	    }
	  };
	
	  NavWrapper.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Wrapper2.default,
	      { className: 'fixed-top' },
	      _react2.default.createElement(
	        _reactstrap.Navbar,
	        { light: true, expand: 'sm' },
	        _react2.default.createElement(
	          _reactstrap.NavbarBrand,
	          { href: '/', style: { boxShadow: "none", margin: "0", border: "none" } },
	          _react2.default.createElement(_Logo2.default, null)
	        ),
	        _react2.default.createElement(_reactstrap.NavbarToggler, { onClick: this.toggle }),
	        _react2.default.createElement(
	          _reactstrap.Collapse,
	          { isOpen: this.state.isOpen, navbar: true },
	          _react2.default.createElement(
	            _reactstrap.Nav,
	            { className: 'ml-auto', navbar: true },
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              { onClick: this.closeNavbar },
	              _react2.default.createElement(
	                _GatsbyLink2.default,
	                { to: '/' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              { onClick: this.closeNavbar },
	              _react2.default.createElement(
	                _GatsbyLink2.default,
	                { to: '/about' },
	                'About'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              { onClick: this.closeNavbar },
	              _react2.default.createElement(
	                _GatsbyLink2.default,
	                { to: '/blog' },
	                'Blog'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              { onClick: this.closeNavbar },
	              _react2.default.createElement(
	                _GatsbyLink2.default,
	                { to: '/contact' },
	                'Contact'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return NavWrapper;
	}(_react2.default.Component);
	
	exports.default = NavWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Nav = __webpack_require__(305);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	__webpack_require__(408);
	
	__webpack_require__(317);
	
	__webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Nav2.default, null),
	      children()
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func,
	  location: _react2.default.PropTypes.object,
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    body{\n        background: #fff;\n        overflow: hidden;\n    }\n\n    a {\n        color: #007acc;\n        text-decoration: none;\n        box-shadow: none;\n        border-bottom: 1px solid transparent;\n        transition: all ease-in-out 0.3s;\n        \n        &:hover{\n            color: #007acc !important;\n            text-decoration: none !important;\n            border-color: #007acc;\n        }\n    }\n\n    /* change navbar background on collapse */\n    @media (max-width: 575px) {\n        nav.navbar {\n            background-color: #fff !important;\n        }\n    }\n\n    .post {\n        ul,ol {\n            padding-left: 20px !important;\n        }\n    }\n}\n'], ['\n    body{\n        background: #fff;\n        overflow: hidden;\n    }\n\n    a {\n        color: #007acc;\n        text-decoration: none;\n        box-shadow: none;\n        border-bottom: 1px solid transparent;\n        transition: all ease-in-out 0.3s;\n        \n        &:hover{\n            color: #007acc !important;\n            text-decoration: none !important;\n            border-color: #007acc;\n        }\n    }\n\n    /* change navbar background on collapse */\n    @media (max-width: 575px) {\n        nav.navbar {\n            background-color: #fff !important;\n        }\n    }\n\n    .post {\n        ul,ol {\n            padding-left: 20px !important;\n        }\n    }\n}\n']);
	
	var _styledComponents = __webpack_require__(10);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject);

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-3c68ff7a5ea758ecfb3c.js